import { styled } from '../theme';

const PageTileHeader = styled('header')(({ theme }) => ({
    flexShrink: 0,
    display: 'flex',
    flexFlow: 'row',
    height: 40,
    alignItems: 'center',
    color: theme.color.jetBlack,
    marginBottom: 30,
}));

export default PageTileHeader;
